/* mixins/app */
import { mapActions, mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters([
            'getDarkMode',
            'getNavigationDrawer',
            'getRecaptchaPublicKey'
        ]),

        getAppContainerClass() {
            return this.getDarkMode ? 'grey darken-4' : 'grey lighten-2'
        },

        getUserInitials() {
            return this.getInitials(this.displayName)
        }
    },

    methods: {
        ...mapActions([
            'setDarkMode',
            'setNavigationDrawer',
            'setRecaptchaPublicKey'
        ]),

        getColorClass(color) {
            return this.getDarkMode ? '' : color
        }
    }
}